module.exports = __webpack_public_path__ + "img/logo.f52c82f8.png";